import * as React from 'react'
import axios from 'axios'
import { usePaywallStore } from './usePaywallStore'
import {
    changeFailureMessage,
    failureCode,
    failureMessage,
} from './checkoutErrors'
import { changeChargeFor } from './checkoutLabels'

// Mode B: switching a paying subscription to the selected plan, after the
// buyer has agreed to the previewed terms.
export function usePlanChange({
    selectedKey,
    selectedPlan,
    period,
    changePreview,
    funnel,
    onDone,
}) {
    const completeUpgrade = usePaywallStore(state => state.completeUpgrade)
    const [agreed, setAgreed] = React.useState(false)
    const [status, setStatus] = React.useState('idle')
    const [error, setError] = React.useState(null)

    // Agreement covers one plan and period: picking another asks again.
    React.useEffect(() => {
        setAgreed(false)
    }, [selectedKey, period])

    async function confirm() {
        funnel.track('upgrade_checkout_started', { method: 'plan-change' })
        setStatus('processing')
        setError(null)
        try {
            const response = await axios.post('/billing/plan/change', {
                plan: selectedPlan.planId,
            })
            completeUpgrade({
                plan: response.data.plan,
                tier: response.data.tier,
                method: 'plan-change',
                amount: response.data.amount,
                currency: response.data.currency,
                direction: response.data.direction,
                code: funnel.funnelCode,
                period,
            })
            setStatus('idle')
            onDone({
                label: selectedPlan.label,
                mode: 'change',
                amount: changeChargeFor(changePreview),
                currency: changePreview && changePreview.currency,
                scheduledFor:
                    response.data.timing === 'end_of_term'
                        ? response.data.effectiveAt
                        : null,
                trialEndsAt:
                    response.data.timing === 'trial'
                        ? response.data.trialEndsAt
                        : null,
            })
        } catch (changeError) {
            funnel.track('upgrade_checkout_failed', {
                method: 'plan-change',
                error_code: failureCode(changeError),
                error_message: failureMessage(changeError),
            })
            setStatus('failed')
            setError(changeFailureMessage(changeError))
        }
    }

    return { agreed, setAgreed, status, error, confirm }
}
